import React, { useEffect } from "react";
import Joyride from "react-joyride";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { COLORS } from "../config/theme";
import {
  updateTourState,
  updateTourStatus,
} from "../redux/actions/Admin/admin.actions";

function ViewAdminRide() {
  const { primaryDark } = COLORS;

  const dispatch = useDispatch();
  const { run, stepIndex, steps, tourDontShow } = useSelector(
    (state) => state.user
  );
  const history = useHistory();
  useEffect(() => {}, []);
  const handleCallback = (data) => {
    const { action, index, lifecycle, type } = data;
    if (action === "close" && type === "step:after") {
      dispatch(updateTourState(false, 0, false)); //run, stepIndex, tourActive
      if (tourDontShow === true) {
        dispatch(updateTourStatus());
      }
      localStorage.setItem("tourShown", JSON.stringify(true));
    }
    if (index === 0) {
      if (action === "next" && type === "step:after") {
        dispatch(updateTourState(true, 1, true)); //run, stepIndex, tourActive≈
      }
    } else if (index === 1 && type === "step:after") {
      if (action === "next") {
        dispatch(updateTourState(true, 2, true)); //run, stepIndex, tourActive≈
      } else if (action === "prev") {
        dispatch(updateTourState(true, 0, true)); //run, stepIndex, tourActive≈
      }
    }
    if (index === 2 && type === "step:after") {
      if (action === "next") {
        dispatch(updateTourState(true, 3, true)); //run, stepIndex, tourActive≈
      } else if (action === "prev") {
        dispatch(updateTourState(true, 1, true)); //run, stepIndex, tourActive≈
      }
    }
    if (index === 3 && type === "step:after") {
      if (action === "next") {
        dispatch(updateTourState(false, 4, true)); //run, stepIndex, tourActive≈
        history.push("/app/wave-cards");
      } else if (action === "prev") {
        dispatch(updateTourState(false, 2, true)); //run, stepIndex, tourActive≈
        history.push("/app");
      }
    }
    if (index === 4 && type === "step:after") {
      if (action === "next") {
        dispatch(updateTourState(true, 5, true)); //run, stepIndex, tourActive
      } else {
        dispatch(updateTourState(true, 3, true)); //run, stepIndex, tourActive≈
      }
    }
    if (index === 5 && type === "step:after") {
      if (action === "next" && lifecycle === "complete") {
        dispatch(updateTourState(false, 0, false)); //run, stepIndex, tourActive
        if (tourDontShow === true) {
          dispatch(updateTourStatus());
        }
        localStorage.setItem("tourShown", JSON.stringify(true));
      } else if (action === "prev") {
        dispatch(updateTourState(true, 4, true)); //run, stepIndex, tourActive≈
      }
    }
    if (action === "skip" && type === "tour:end") {
      dispatch(updateTourState(false, 0, false)); //run, stepIndex, tourActive
      if (tourDontShow === true) {
        dispatch(updateTourStatus());
      }
      localStorage.setItem("tourShown", JSON.stringify(true));
    }
  };

  return (
    <Joyride
      callback={handleCallback}
      continuous
      run={run}
      scrollToFirstStep
      disableScrollParentFix={true}
      stepIndex={stepIndex}
      showProgress
      showSkipButton
      steps={steps}
      styles={{
        options: {
          arrowColor: "white",
          backgroundColor: "white",
          primaryColor: primaryDark,
          textColor: "black",

          zIndex: 10000,
        },
      }}
    />
  );
}

export default ViewAdminRide;
